import { Button } from '../../../../components';
import styles from './index.module.css';
import aboutus from './images/aboutus.png';

const text = {
    cn: {
        title: '关于我们',
        content1: '我们是ProLogue LLC，中文名为序幕体育，位于美国新泽西州。这是一家以见证和记录动人的体育人和体育故事为宗旨的体育内容相关服务公司。',
        content2: '它分为几个业务内容部分，第一为视频内容的拍摄和制作，包括纪录片、宣传片、以及一些为播出平台所需生产的节目和直播活动。第二，为体育相关的合作方及客户的需求提供包括经纪、策划、联络、执行和运营等服务。目前，ProLogue已与NBA中国、布鲁克林篮网队、Priority、WME、GZY、River Light、沃瑟曼体育经纪公司、腾讯和快手体育、壹球体育、疯狂体育等形成了合作关系。',
        button: '了解更多'
    },
    en: {
        title: 'ABOUT US',
        content1: 'ProLogue (Chinese: 序幕) LLC is a sports media content production company based out of New Jersey, USA. We aim to serve our fans by capturing and presenting authentic, unique and moving stories in the world of sports and its people.',
        content2: 'ProLogue specializes in directing, filming and post-production of video content, including documentaries, promos and other materials serving live and OTT platforms. We also provide customized all-encompassing services covering planning, coordination, execution and operational phases of sporting events.',
        button: 'learn more'
    }
}

const AboutUs = (props) => {
    const { 
        // currentIndex,
         l = 'cn', isShowBtn, setPath } = props;
    return (
        <div className={styles['page']}>
            <div
                className={styles['page-content']}
                style={{
                    // top: currentIndex === 1 ? 0 : 300,
                    // opacity: currentIndex === 1 ? 1 : 0,
                }}
            >
                <div className={styles['content']}>
                    <div className={styles['left']}>
                        <div className={styles['left-content']}>
                            <div className={styles['title']}>{text[l]['title']}</div>
                            <div className={styles['line']}>&nbsp;</div>
                            <div className={styles['content1']}>
                                {text[l]['content1']}
                            </div>
                            <div className={styles['content2']}>
                                {text[l]['content2']}
                            </div>
                            {isShowBtn && <Button title={text[l]['button']} onClick={() => {
                                setPath('About US')
                            }} />}

                        </div>
                    </div>
                    <div className={styles['right']}>
                        <div className={styles['right-content']}>
                            <img src={aboutus} style={{ width: '100%' }} alt=''/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUs;